import React from "react";
import { Link } from "react-router-dom";
import { SITE_URL } from "@/config/site";
import SEO from "@/components/SEO";
import VoiceDirectory from "@/components/VoiceDirectory";
import { CHILD_VOICES, CHILD_VOICE_ORDER } from "@/config/childVoices";
import { ArrowRight } from "lucide-react";

export default function ChildVoices() {
  const jsonLd = {
    "@context": "https://schema.org", "@type": "CollectionPage",
    name: "Kinderstemacteurs",
    url: SITE_URL + "/kinderstemmen",
    description: "Overzicht van professionele kinderstemacteurs in 25+ talen.",
  };

  return (
    <>
      <SEO title="Kinderstemacteurs" path="/kinderstemmen"
        description="Bekijk professionele kinderstemacteurs in 25+ talen. Beluister demo's, filter op taal, land, geslacht en stemleeftijd, maak een shortlist en cast."
        jsonLd={jsonLd} />

      <section className="bg-brand-ink text-white">
        <div className="container-x py-14 md:py-16">
          <span className="label-eyebrow text-brand-purple">Stemmendatabase</span>
          <h1 className="mt-2 font-heading text-4xl font-black tracking-tighter md:text-5xl">Kinderstem acteurs</h1>
          <p className="mt-3 max-w-2xl text-zinc-300">
            Vind jong stemtalent in meer dan 30 talen. Doorzoek ons bestand met kinderstemmen op taal,
            land, geslacht en stemleeftijd, luister naar demo's, maak een shortlist en vind de perfecte kinderstem voor jouw productie.
          </p>
        </div>
      </section>

      <div className="container-x -mt-8 pb-4">
        <VoiceDirectory />
      </div>

      {/* Browse by language — crawlable internal links to every landing page */}
      <section className="bg-white border-t border-zinc-200 py-14">
        <div className="container-x">
          <span className="label-eyebrow text-brand-violet">Bekijk per taal</span>
          <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight md:text-3xl">Kinderstemacteurs per taal</h2>
          <p className="mt-3 max-w-2xl text-zinc-600">Ontdek ons gespecialiseerde kinderstemtalent per taal en accent.</p>
          <div className="mt-8 grid gap-x-6 gap-y-2.5 sm:grid-cols-2 lg:grid-cols-3">
            {CHILD_VOICE_ORDER.map((slug) => (
              <Link key={slug} to={`/kinderstemmen/${slug}`} data-testid={`browse-lang-${slug}`}
                className="group inline-flex items-center gap-2 text-zinc-700 transition hover:text-brand-violet">
                <ArrowRight size={14} className="text-brand-violet opacity-60 transition group-hover:translate-x-0.5" />
                <span className="font-semibold">{CHILD_VOICES[slug].h1}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
